import React, { useState } from 'react';
import Carousel from 'react-slick';
import PlayAudioControl from 'components/PlayAudioControl';
import ImagePlaceholder from 'assets/img/image_placeholder.jpg';

const SwipeCarousel = (
  { 
    data, 
    onPlay, 
    onPause, 
    onNext, 
    initialSlide,
    audioEnded, 
    afterChangeCb, 
    beforeChangeCb,
  },
  ref
) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    initialSlide: initialSlide,
  };

  const [showControl, setShowControl] = useState(true);

  const afterChange = (index) => {
    setShowControl(true);
    onNext(index);
    afterChangeCb();
  };

  const beforeChange = () => {
    setShowControl(false);
    onPause();
    beforeChangeCb();
  };

  return (
    <Carousel
      id='home'
      ref={ref}
      style={{ borderRadius: '5px', height: '100%' }}
      afterChange={afterChange}
      beforeChange={beforeChange}
      {...settings}
    >
      {data.map((item, i) => (
        <div key={`${item.title}_${i}`} style={{ borderRadius: '10px' }}>
          <img
            style={{
              height: '100%',
              borderRadius: '10px 10px 0 0',
            }}
            src={item.imgsrc || ImagePlaceholder}
            alt='Slide1'
            className='slick-image'
          />

          <div>
            <div style={{ marginTop: '30px', fontSize: '25px' }}>
              <b>{item.artist}</b>
            </div>
            <div
              style={{
                fontSize: '20px',
                marginTop: '15px',
                paddingBottom: '20px',
              }}
            >
              {item.title}
            </div>
          </div>
          <div
            style={{
              top: '110px',
              left: '100px',
              zIndex: '10',
              position: 'absolute',
            }}
          >
            {showControl && (
              <PlayAudioControl
                onPlay={onPlay}
                onPause={onPause}
                audioEnded={audioEnded}
              />
            )}
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default React.forwardRef(SwipeCarousel);
